import React, { FC, useState } from 'react';
import 'react-dates/initialize';
import RealEstateSearchForm from './RealEstateSearchForm';

const HeroRealEstateSearchForm: FC<any> = ({}) => {
  return <RealEstateSearchForm />;
};

export default HeroRealEstateSearchForm;
